<div class="row bg-white">
    <div class="animated fadeInLeft col-12 col-lg-6 col-xl-5 section-login-form order-2 order-lg-1">
        <div class="row text-right">
            <div class="col-12">
                <app-language-picker [extraClass]="'d-none d-lg-inline'"></app-language-picker>
            </div>
        </div>
        <div class="row mb-5 pb-3">
             <div class="col-12">
                  <a (click)="goToHomeLanding()">
                      <img class="logo" src="assets/img/logo.png" />
                 </a>
             </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <h2> {{ 'rememberpasssword.Cambio de contraseña' | translate }} </h2>
                <h5> {{ 'rememberpasssword.Indica tu nueva contraseña de acceso' | translate }}. </h5>
            </div>
        </div>

        <form action="" [formGroup]="rememberPasswordConfirmForm" class="form-underline">

            <div class="row mb-4">
                <div class="col-12">
                    <div class="field pb-2">
                        <input formControlName="newPassword" type="password" name="newPassword" id="newPassword" placeholder="{{ 'rememberpasssword.Nueva contraseña' | translate }}" value="">
                        <label for="newPassword">{{ 'rememberpasssword.Nueva contraseña' | translate }}</label>
                    </div>
                    <app-feedback [formGroup]="rememberPasswordConfirmForm" field="newPassword" validator="required" feedback="{{ 'rememberpasssword.Contraseña nueva requerida' | translate }}" [refresh]="refreshValidators"></app-feedback>
                    <app-feedback [formGroup]="rememberPasswordConfirmForm" field="newPassword" validator="maxlength" feedback="{{ 'createtourdetails.Texto demasiado largo' | translate }}" [refresh]="refreshValidators"></app-feedback>

                    <div class="field pb-2">
                        <input formControlName="retryPassword" type="password" name="retryPassword" id="retryPassword" placeholder="{{ 'rememberpasssword.Confirmar contraseña' | translate }}" value="">
                        <label for="retryPassword">{{ 'rememberpasssword.Confirmar contraseña' | translate }}</label>
                    </div>
                    <app-feedback [formGroup]="rememberPasswordConfirmForm" field="retryPassword" validator="required" feedback="{{ 'rememberpasssword.Confirmación de contraseña requerida' | translate }}" [refresh]="refreshValidators"></app-feedback>
                    <app-feedback [formGroup]="rememberPasswordConfirmForm" field="retryPassword" validator="noequals" feedback="{{ 'rememberpasssword.Contraseña nueva y su confirmación no coinciden' | translate }}" [refresh]="refreshValidators"></app-feedback>
                    <app-feedback [formGroup]="rememberPasswordConfirmForm" field="retryPassword" validator="maxlength" feedback="{{ 'createtourdetails.Texto demasiado largo' | translate }}" [refresh]="refreshValidators"></app-feedback>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-6">
                    <input type="submit" (click)="rememberPassword()" value="{{ 'rememberpasssword.Guardar' | translate }}" class="btn btn-full-width btn-primary mb-3 mb-sm-0" />
                </div>
                <div class="col-12 col-sm-6">
                    <a (click)="goToLogin()" class="btn btn-full-width btn-secondary">{{ 'rememberpasssword.Volver' | translate }}</a>
                </div>
            </div>

        </form>
    </div>

    <div app-access-side-panel class="col-12 col-lg-6 col-xl-7 section-login-bg d-flex align-items-start flex-column order-1 order-lg-2"></div>
</div>

<app-message-panel></app-message-panel>